<template>
  <div class="additional-function">
    <button
      class="btn square w-32px h-32px mb-1"
      @click="$emit('update:isModalShow', !isModalShow)"
    >
      <v-icon>more_horiz</v-icon>
    </button>
    <div class="block blcok-3 w-150px" v-if="isModalShow">
      <div
        class="py-14px pl-10px selection-item-hover"
        @click="copyPictureLink(imgData)"
      >
        <input type="hidden" :id="`input-${imgData.id}`" :value="addDomain(imgData.url)" />
        複製圖片連結
      </div>
      <div
        class="py-14px pl-10px selection-item-hover"
        @click="removePicture(imgData)"
      >
        移除圖片
      </div>
      <div
        class="py-14px pl-10px selection-item-hover"
        @click="manageFolder(imgData)"
      >
        資料夾管理
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isModalShow: {
      type: Boolean,
      default: true,
    },
    imgData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    copyPictureLink() {
      /* select input */
      const testingCodeToCopy = document.querySelector(
        `#input-${this.imgData.id}`,
      );
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();
      /* copy text */
      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        console.log(`Testing code was copied ${msg}`);
      } catch (err) {
        console.log('Oops, unable to copy');
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();

      this.$emit('update:isModalShow', false);
    },
    removePicture(imgData) {
      this.$emit('remove-picture', imgData.id);
      this.$emit('update:isModalShow', false);
    },
    manageFolder(imgData) {
      this.$emit('manage-folder', imgData);
      this.$emit('update:isModalShow', false);
    },
    addDomain(url) {
      if (url.indexOf('/storage/') === 0) {
        return `${process.env.VUE_APP_HOST}${url}`;
      }

      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-function {
  &__option {
    padding: 14px 10px;
    padding-right: 0px;
  }
}
</style>
